module.exports = __webpack_public_path__ + "img/kl_wsjj.eb9fa7a5.png";